var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import uuid from "uuid";
import serverUri from "../../config";
import { WebSocketMessage } from "../../serverConnection";
import AreaSelect from "../common/AreaSelect";
import EnterpriseSelect from "../common/EnterpriseSelect";
import Spinner from "../common/Spinner";
import DropzoneInput from "./DropzoneInput";
var uploadHomeVideo = function (data, history, token) {
    Axios.defaults.headers.common.Authorization = token;
    Axios.post(serverUri + "/api/videos/upload", data);
    history.push("/videos");
};
var HomeUpload = /** @class */ (function (_super) {
    __extends(HomeUpload, _super);
    function HomeUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.storePreview = function () {
            var files = __spreadArrays(_this.state.files);
            files[0].preview = URL.createObjectURL(files[0]);
            _this.setState({ files: files });
        };
        _this.onSubmit = function () {
            var formData = new FormData();
            var file = _this.state.files[0];
            formData.append("id", _this.state.video.id);
            formData.append("name", file.name);
            formData.append("video", file);
            formData.append("enterprise", _this.state.enterprise.id);
            _this.setState({ uploading: true }, function () {
                var video = __assign({}, _this.state.video);
                video.enterprise = _this.state.enterprise.id;
                _this.props.send(WebSocketMessage("videos", "update", video));
                uploadHomeVideo(formData, _this.props.history, _this.props.token);
            });
            _this.props.send(WebSocketMessage("videos", "update", _this.state.video));
        };
        _this.state = {
            uploading: false,
            enterprise: _this.props.enterprises[0],
            video: {
                id: uuid.v1(),
            },
            files: [],
        };
        return _this;
    }
    HomeUpload.prototype.render = function () {
        var _this = this;
        if (!this.props.enterprises) {
            return React.createElement(React.Fragment, null);
        }
        var uploading = this.state.uploading;
        var content = function () {
            switch (true) {
                case uploading:
                    return React.createElement(Spinner, null);
                default:
                    return (React.createElement("div", { className: "content container" },
                        React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                            React.createElement("h5", null, "Upload your own Ad"),
                            React.createElement("br", null),
                            React.createElement(DropzoneInput, { name: "video", files: _this.state.files, reset: function () {
                                    URL.revokeObjectURL(_this.state.files[0].preview);
                                    _this.setState({ files: [] });
                                }, onChange: function (files) {
                                    _this.setState({ files: files }, _this.storePreview);
                                } }),
                            React.createElement("div", { className: "card-panel" },
                                React.createElement(EnterpriseSelect, { notEmpty: true, value: _this.state.enterprise.id, enterprises: _this.props.enterprises, setEnterprise: function (id) {
                                        return _this.setState(__assign(__assign({}, _this.state), { enterprise: _this.props.enterprises.find(function (en) { return id === en.id; }) }));
                                    } }),
                                React.createElement(AreaSelect, { enterprise: _this.state.enterprise, value: _this.state.video.area, onChange: function (area) { return _this.setState({ video: __assign(__assign({}, _this.state.video), { area: area }) }); } })),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("button", { type: "submit", disabled: _this.state.files.length !== 1, className: "right teal btn-flat white-text", onClick: function () { return _this.onSubmit(); } }, "Upload"),
                            React.createElement(Link, { to: "/videos", className: "red btn-flat left white-text" }, "Cancel"),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("br", null))));
            }
        };
        return React.createElement("div", null, content());
    };
    return HomeUpload;
}(Component));
export default HomeUpload;



//////////////////
// WEBPACK FOOTER
// ./src/components/videos/HomeUpload.tsx
// module id = 1247
// module chunks = 0